import styled from "styled-components";

export const $RetailerLogoLink = styled.a`
  .helper-text {
    display: none
  }
  cursor: pointer;
`;